
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateExternalDocumentLinkDtoFormGroup() {
return new FormGroup({
    localDocumentId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalDocumentId: new FormControl<number | undefined>(undefined, [Validators.required]),
    projectLinkId: new FormControl<number | undefined>(undefined),
})
;
}
      